import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class irenwebGas {
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 110,
        Id_Foritore: 1,
        Id_comodity: 2,
        TipoContratto:1,
        NomeOfferta: "GAS WEB PLUS",
        LinkFoto: "./assets/images/offerte-iren/web-gas-plus.jpg",
        LinkFotoLarge: "./assets/images/offerte-iren/web-gas-plus.jpg",
        LinkFotoMid: "./assets/images/offerte-iren/web-gas-plus.jpg",
        LinkFotoSm: "./assets/images/offerte-iren/web-gas-plus.jpg",
        LinkFotoCarousel: "./assets/images/offerte-iren/web-gas-plus.jpg",
        DescrizioneCarousel: "Che Offerta super",
        DescrizioneNomeOfferta: "Iren luce gas e servizi, propone un’offerta luce e/o gas studiata in base ai bisogni delle famiglie e delle piccole aziende che sempre più spesso chiedono prezzi allineati alle proprie abitudini di consumo (da qui la nascita delle tariffe MONORARIE, BIORARIE, ecc.).",
        PromozioneOfferta: "",
        Sezioni: [
          {
            NomeSezione: "RISPARMIO ASSICURATO",
            DescrizioneSezione: "Per risparmiare sulle bollette di luce e gas, la soluzione migliore è quella di acquisire comportamenti che limitino il consumo. Sappiamo che gli sprechi di energia elettrica e gas in casa sono comuni ed è faticoso far cambiare abitudini a tutta la famiglia. Per questo motivo scegliere una offerta di luce e gas conveniente è la soluzione che può portare a concreti risparmi in bolletta.",
            lstPunti: []
          },
          {
            NomeSezione: "",
            DescrizioneSezione: "Scegliere Iren luce gas e servizi conviene!",
            lstPunti: [
            ]

          },
          {
            NomeSezione: "",
            DescrizioneSezione: "IREN Web: la comodità del web e un prezzo bloccato per un anno.",
            lstPunti: [
            ]

          }
        ],
        PrezzoEle: 0,
        PrezzoGas: 0.279,
       
        TitoloPlus: "Vantaggi assicurati",
        Plus: ["Prezzo bloccato per 1 anno", "Nessuna spesa di passaggio al mercato libero",
        "Nessun costo aggiuntivo"]
        ,schedaconfrontabilitaele:
        {
          tabellaConfrontabilita:[]
        }
        ,schedaconfrontabilitagas:  { tabellaConfrontabilita:[ { zona:1, consumoannuo:120,importo:128.22}
,{ zona:1, consumoannuo:480,importo:309.19}
,{ zona:1, consumoannuo:700,importo:362.25}
,{ zona:1, consumoannuo:1400,importo:634.73}
,{ zona:1, consumoannuo:2000,importo:866.49}
,{ zona:1, consumoannuo:5000,importo:2022.02} 
,{ zona:2, consumoannuo:120,importo:118.47}
,{ zona:2, consumoannuo:480,importo:290.41}
,{ zona:2, consumoannuo:700,importo:338.30}
,{ zona:2, consumoannuo:1400,importo:594.33}
,{ zona:2, consumoannuo:2000,importo:811.95}
,{ zona:2, consumoannuo:5000,importo:1896.76} 
,{ zona:3, consumoannuo:120,importo:124.70}
,{ zona:3, consumoannuo:480,importo:307.99}
,{ zona:3, consumoannuo:700,importo:362.34}
,{ zona:3, consumoannuo:1400,importo:638.93}
,{ zona:3, consumoannuo:2000,importo:874.22}
,{ zona:3, consumoannuo:5000,importo:2047.43} 
,{ zona:4, consumoannuo:120,importo:120.13}
,{ zona:4, consumoannuo:480,importo:311.50}
,{ zona:4, consumoannuo:700,importo:370.32}
,{ zona:4, consumoannuo:1400,importo:661.14}
,{ zona:4, consumoannuo:2000,importo:908.68}
,{ zona:4, consumoannuo:5000,importo:2143.20} 
,{ zona:5, consumoannuo:120,importo:132.99}
,{ zona:5, consumoannuo:480,importo:334.52}
,{ zona:5, consumoannuo:700,importo:398.99}
,{ zona:5, consumoannuo:1400,importo:707.78}
,{ zona:5, consumoannuo:2000,importo:970.77}
,{ zona:5, consumoannuo:5000,importo:2282.63} 
,{ zona:6, consumoannuo:120,importo:140.13}
,{ zona:6, consumoannuo:480,importo:359.75}
,{ zona:6, consumoannuo:700,importo:434.28}
,{ zona:6, consumoannuo:1400,importo:775.05}
,{ zona:6, consumoannuo:2000,importo:1065.55}
,{ zona:5, consumoannuo:5000,importo:2515.12}]}

        ,lstModalitaPagamento :["2"]
        ,scontoRid:0 
        ,TipoSoglieEle: Soglie.SoglieEle4Fasce()
        ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
      };
    }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/irenwebGas.ts